import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const mock = [
  {
    title: 'Política de privacidad y tratamiento de datos personales',
    description: `hauscanner.com (como se conocerá en adelante), crea la siguiente política de privacidad y tratamiento de los datos que sean recolectados provenientes de personas, tanto naturales como jurídicas durante y después de la prestación del servicio de información prestado, con fines estrictamente relacionados con aspectos comerciales, garantizando el derecho de todos los intervinientes a conocer, actualizar y rectificar las informaciones que sobre ellos se hubiere recogido.`,
  },
  {
    title: 'POLITICA DE TRATAMIENTO DE DATOS',
  },
  {
    title: 'Nombre: SITE S.A.S.',
  },
  {
    title: 'Teléfono: +57 314 5410430',
  },
  {
    title: 'Correo electrónico: info@hauscanner.com',
  },
  {
    title: 'Encargado del tratamiento de datos:',
    description: `SITE S.A.S., se encargará de la recolección, almacenamiento, manejo, trasmisión, rectificación, actualización y protección de los datos provenientes de los usuarios de la plataforma, así como de terceros.`,
  },
  {
    title: 'Recolección de la información',
    description: `SITE S.A.S. recibe y almacena información sobre usted, la cual incluye:

      La información que usted nos entrega: Compilamos información que usted nos entrega en diferentes momentos, como lo son:`,
  },
  {
    description: `► Al momento de interactuar a través de la aplicación móvil, de la plataforma web o de cualquier otro medio de contacto establecido con hauscanner.com, se solicitarán datos para poder prestar el servicio ofrecido por la plataforma en los siguientes puntos de interacción:`,
  },
  {
    description: `► Al momento de que el usuario comprador o arrendatario utiliza los servicios inmobiliarios ofrecidos dentro de la plataforma, al momento de que el usuario vendedor o que publica una propiedad ofrece los servicios inmobiliarios dentro de la plataforma.`,
  },
  {
    description: `►Cuando existe interacción con nuestro servicio al cliente.`,
  },
  {
    description: `►Cuando usted presenta solicitudes, quejas o reclamos ante hauscanner.com y le solicitamos datos para poder solucionar su inconformidad.`,
  },
  {
    description: `►Cuando usted participa en encuestas o promociones de marketing.`,
  },
  {
    description: `►Cuando usted nos proporciona reseñas, calificaciones o preferencias.`,
  },
  {
    description: `►Cuando la plataforma necesite información adicional para uso del servicio y la solicite directamente.`,
  },
  {
    description: `► Información compilada automáticamente: Recopilamos información relacionada con usted, el uso de nuestro servicio, sus interacciones con nosotros y la publicidad, igualmente de aquella información relacionada con el dispositivo que usted utiliza para acceder a nuestro servicio. Algunos ejemplos de lo que incluye esta información son:`,
  },
  {
    description: `ID de dispositivos u otros identificadores únicos, características de software y dispositivo, información de conexión, estadísticas sobre visualización de las paginas, URL de referencias, direcciones IP, Su ubicación para prestarle un mejor servicio.
      La información compilada a través del uso de cookies, señalizaciones web y otras tecnologías, incluidos datos de publicidad (información sobre la disponibilidad y entrega de anuncios, el URL del sitio, así como la fecha y horas).`,
  },
  {
    description: `► Información de otras fuentes: También complementamos información anterior con información de otras fuentes, como proveedores de datos obtenidos tanto online como sin offline. La información puede incluir datos demográficos, datos basados en los intereses y conductas de navegación por internet.`,
  },
  {
    title: '¿Como usamos tu información?',
    description: `Usamos la información compilada para procesar su registro, solicitudes, analizar, administrar, mejorar y personalizar nuestros servicios e iniciativas de marketing, para comunicarnos con usted y para prestarle un servicio cada vez mejor, por ejemplo, la utilizamos para lo siguiente:

      Determinar la ubicación geográfica donde se encuentra, con el fin de acceder y/o prestar los servicios de información que estén ubicados en su posición geográfica, ofrecerle contenidos, brindarle recomendaciones, determinar su proveedor de servicio de internet, ofrecerle información comercial, responder con mayor eficiencia a las consultas y solicitudes, y demás que sean necesarias para prestarle un mejor servicio de información.
      Compartirla con los usuarios vendedores o que publican una propiedad para la gestión de la información integral de los servicios que le prestan a los usuarios compradores o arrendatarios.

      Detectar, prevenir e investigar actividades prohibidas, como el fraude, hacer cumplir nuestros términos.

      Analizar y comprender a nuestros usuarios, mejorar nuestro servicio y optimizar la selección de los contenidos, los algoritmos de recomendación y la entrega.

      Comunicarnos con usted de acuerdo a nuestro servicio (notificaciones, email, mensajes de texto y mensajería online), con el fin de enviarle noticias sobre la plataforma hauscanner.com, nuevas funciones y también ofertas que mejoren su experiencia. También para solucionar temas operativos como problemas técnicos.`,
  },
  {
    description: `Transferencia de información: Transferimos su información a terceros con el fin de mejorar su experiencia como usuario y que usted acceda a promociones y beneficios efectivos relacionados con el servicio.`,
  },
  {
    title: 'Tratamiento específico:',
    description: `Los datos que sean aportados por los usuarios de la plataforma y demás terceros, serán sujetos a recolección, almacenamiento, uso, transferencia, transmisión, supresión o suspensión, modificación, actualización, observando en todo lugar, los principios de Seguridad y confidencialidad, así como también, el deber de informar a todos aquellos que hayan aportado datos, sobre cualquier alteración que involucre dicha información.

      En vista de lo anterior, solo las personas que demuestren estar autorizadas por parte de los titulares de la información ya sea para su retiro, modificación o alteración de cualquier tipo, se les permitirá realizar dichas actividades, aquellos que no se les negara esta posibilidad, éstas, deberán expresarse en forma escrita por parte del titular de la información describiendo claramente su deseo frente al manejo de sus datos.

      Los datos serán utilizados con las siguientes finalidades entre otras:

      Recolectar en la base de datos de hauscanner.com información necesaria para el ingreso a la plataforma de los usuarios ( usuarios vendedores o que publican una propiedad y usuarios compradores o arrendatarios ).
      Almacenar dicha información en las bases de datos de hauscanner.com.
      Estudiar dicha información con fines de mejorar los servicios de información que disponga hauscanner.com.
      Suspender, sustituir, eliminar y modificar los datos inscritos contando con el consentimiento informado y previo del titular de los mismos en concordancia con los términos y condiciones.
      Enviar información comercial a los usuarios de hauscanner.com.
      Manejo responsable de los datos que ingresen en la base de datos de hauscanner.com.

      Analizar el comportamiento de los usuarios con el propósito de mejorar aspectos estructurales de hauscanner.com.

      Transferir datos entre los usuarios de la plataforma ( usuarios prestadores de servicio y usuarios tomadores del servicio ) con el fin de que los servicios concurrentes entre éstos se presten óptimamente.
      Prestar los servicios relacionados con la naturaleza de hauscanner.com.`,
  },
  {
    title: 'QUEJAS, RECLAMOS, SOLICITUDES:',
    description: `hauscanner.com consciente de su compromiso con los datos que son aportados por todos los usuarios serán atendidos, escribiendo al correo electrónico: info@hauscanner.com`,
  },
  {
    title: 'VIGENCIA:',
    description: `La presente política de datos comenzará a regir a partir de su publicación en la plataforma de hauscanner.com y podrá ser modificada en cualquier momento por la plataforma.`,
  },
];

const PrivacySection = ({ title, description }: any) => {
  return (
    <Box>
      <Typography
        variant={'h6'}
        gutterBottom
        sx={{
          fontWeight: 'medium',
        }}
      >
        {title}
      </Typography>
      <Typography component={'p'} color={'text.secondary'}>
        {description}
      </Typography>
    </Box>
  );
};

const Content = () => {
  return (
    <Box>
      {mock.map((item, i) => (
        <Box key={i} marginBottom={i < mock.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
